export const ANALYTIC = {
  GTM_ID: import.meta.env.VITE_GTM_ID || '',
};
